<template>
  <div class="copyright">
    <a href="https://neutron.sg/" target="_blank" rel="noopener noreferrer">
      <el-image :src="logo" class="logo"></el-image>
      <span>© {{ year }} Powered by NeuCommerce</span>
    </a>
  </div>
</template>

<script>
export default {
  name: 'app-footer',
  data () {
    return {
      logo: require('@/assets/default/neu-logo.svg'),
      year: new Date().getFullYear()
    }
  }
}
</script>

<style lang="scss">
.copyright {
  text-align: center;
  // background-color: #f8f9fb;
  padding: 20px 0;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  a {
    text-decoration: none;
    color: #909399;
    font-weight: 500;
    display: flex;
    align-items: center;
  }
  .logo {
    // width: 100px;
    margin-right: 7px;
  }
}
</style>
